// Copyright 2018 Ping Identity
//
// Licensed under the MIT License (the "License"); you may not use this file
// except in compliance with the License.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// NTS 06/19/25 Localhost:4200 does NOT work in pre-prod or production mode.

import { AuthorizationConfig, GeneralEnvironmentInfo } from '../app/authorization_config';

export const environment: AuthorizationConfig & GeneralEnvironmentInfo = {
  production: true,
  // Dev
  // apiURL: "https://dev.ncbold.com/api", //"https://localhost:7189/api"; 
  // issuer_uri: 'https://login.mynciddev.nc.gov', //'https://accounts.google.com',
  // client_id: '8b8de75890137857a6d65e40d327717a', // '465844544800-5kuaera626plvvp1c4r9vsevjufrnm2f.apps.googleusercontent.com',
  // client_secret: 'Q4gDPuUPFUG0jSksuDnWfHS7iBzs59vHyFI9ONPa7XargR9fQ3Xyx23ypbncghWB',  //   //'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',
  // redirect_uri: 'http://localhost:4200/callback',
  // extras: {
  //   'end_session_endpoint': `https://login.mynciddev.nc.gov/idp/startSLO.ping?TargetResource=${window.location.origin}`,
  //   'access_type': 'offline'
  // }

  // Pre-prod
  // apiURL: '/api',
  // issuer_uri: 'https://login.myncidpp.nc.gov', 
  // client_id: 'a96aef2cee27257593aa0d28fbb7b3a4', 
  // client_secret: 'IaNbIJkocjcg6J5GwRM87rvw0V6ZoPrWuMnw15ZS82BheHQYsBRnuJSKiBqz6Jcj', 
  // redirect_uri: 'https://dev.ncbold.com/callback',  
  // extras: {
  //   'end_session_endpoint': `https://login.myncidpp.nc.gov/idp/startSLO.ping?TargetResource=${window.location.origin}`,
  //   'access_type': 'offline'
  // }

  // Prod
  apiURL: '/api',
  issuer_uri: 'https://login.myncid.nc.gov',
  client_id: 'db93ad86f2352b9c31652a067b74cdc3',
  client_secret: 'HnZ17hZTDCXwPKLxR1pTFc4H5gA2bp0o2hb0YNLK8kfd2vTX5MFXzRQNBBCrj6Xc',
  redirect_uri: 'https://ncbold.com/callback',
  extras: {
    'end_session_endpoint': `https://login.myncid.nc.gov/idp/startSLO.ping?TargetResource=${window.location.origin}`,
    'access_type': 'offline'
  }
};